/**
 * @generated SignedSource<<b2f9b59d414f412818a49bb463e5242e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLLlmInteractionStatus = "COMPLETED" | "FAILED" | "INTERRUPTED" | "IN_PROGRESS" | "PENDING" | "SKIPPED" | "%future added value";
export type SendMessageInput = {
  attachments?: ReadonlyArray<AttachmentInput> | null | undefined;
  context?: string | null | undefined;
  contextData?: string | null | undefined;
  jobRunId?: any | null | undefined;
  llmConversationId?: any | null | undefined;
  message: string;
};
export type AttachmentInput = {
  handle: string;
};
export type useSendLlmMessageMutation$variables = {
  input: SendMessageInput;
};
export type useSendLlmMessageMutation$data = {
  readonly sendMessage: {
    readonly llmConversation: {
      readonly id: any;
      readonly llmInteractions: ReadonlyArray<{
        readonly id: any;
        readonly status: GraphQLLlmInteractionStatus;
      }>;
    };
    readonly userMessage: {
      readonly content: string;
      readonly id: string;
    };
  };
};
export type useSendLlmMessageMutation = {
  response: useSendLlmMessageMutation$data;
  variables: useSendLlmMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendMessagePayload",
    "kind": "LinkedField",
    "name": "sendMessage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLFormattedMessage",
        "kind": "LinkedField",
        "name": "userMessage",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLLlmConversation",
        "kind": "LinkedField",
        "name": "llmConversation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLLlmInteraction",
            "kind": "LinkedField",
            "name": "llmInteractions",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSendLlmMessageMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSendLlmMessageMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2676cd42c73284aef2bda5140699857f",
    "id": null,
    "metadata": {},
    "name": "useSendLlmMessageMutation",
    "operationKind": "mutation",
    "text": "mutation useSendLlmMessageMutation(\n  $input: SendMessageInput!\n) {\n  sendMessage(input: $input) {\n    userMessage {\n      id\n      content\n    }\n    llmConversation {\n      id\n      llmInteractions {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e1fec631507c4217af85170b04a2f89";

export default node;
